import { IconButton, Stack } from '@fluentui/react';
import React, { useState } from 'react';
import { DataAccessPolicyRow } from '../list';
import { FormModal } from './FormModal';

export interface DataAccessPolicyModalProps {
  existingDataAccessPolicy?: DataAccessPolicyRow;
}

export const DataAccessPolicyModal: React.FC<DataAccessPolicyModalProps> = ({
  existingDataAccessPolicy,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { _isUpdatable } = { ...existingDataAccessPolicy };

  return (
    <Stack>
      <IconButton
        iconProps={{ iconName: 'Edit' }}
        onClick={() => setIsOpen(true)}
        disabled={!_isUpdatable}
      />
      {isOpen && (
        <FormModal
          existingDataAccessPolicy={existingDataAccessPolicy}
          onClose={() => setIsOpen(false)}
        />
      )}
    </Stack>
  );
};
